<template>
  <div class="pt-4">
    <v-container fluid class="px-15">
      <!-- Título y subtítulo -->
      <v-row justify="start" align="start" class="ma-0 mb-4 mt-5">
        <v-col cols="12" class="pa-0">
          <div style="font-family: 'montserrat-bold'; font-size: 32px; color: #193D6E;">
            Contratos activos de factoraje
          </div>
        </v-col>
        <v-col cols="12" class="pa-0">
          <div style="font-family: 'montserrat-regular'; font-size: 14px;">
            Aquí puedes revisar todos los contratos firmados con tus clientes para ceder facturas.
          </div>
        </v-col>
      </v-row>

      <!-- Buscador -->
      <v-row class="ma-0 mb-4" style="align-items: center;">
        <v-col cols="12" sm="4" md="3" class="pl-0">
          <v-text-field
            v-model="search"
            label="Buscar cliente"
            hide-details
            append-icon="mdi-magnify"
            outlined
            style="font-family: 'montserrat-medium'; border-radius: 20px; background-color: white;"
          />
        </v-col>
      </v-row>

      <!-- Tabla de contratos -->
      <v-data-table
        class="d-none d-sm-block"
        :headers="headers"
        :items="contratos"
        :search="search"
        hide-default-header
      >
        <template v-slot:header="{ props }">
          <thead style="background-color: #f9fafd;">
            <tr>
              <th class="header__title left">Cedente</th>
              <th class="header__title center">Deudor</th>
              <th class="header__title center">Fecha</th>
              <th class="header__title center">Línea autorizada</th>
              <th class="header__title center">Tasa</th>
              <th class="header__title center">Días crédito</th>
              <th class="header__title center">Firmas</th>
              <th class="header__title center">Contrato</th>
            </tr>
          </thead>
        </template>

        <template v-slot:body="{ items }">
          <tbody style="background: #f9fafd;">
            <tr v-for="item in items" :key="item.id">
              <td class="table__item">{{ item.cedente_name }}</td>
              <td class="table__item">{{ item.deudor_name }}</td>
              <td class="table__item center">{{ formatDate(item.created_at) }}</td>
              <td class="table__item center">${{ formatMoney(item.linea_autorizada) }} USD</td>
              <td class="table__item center">{{ item.tasa_interes }} %</td>
              <td class="table__item center">{{ item.dias_credito }} días</td>
              <td class="table__item center">
                <v-chip
                  v-for="rol in ['Deudor', 'Cedente', 'Admin']"
                  :key="rol"
                  :color="item.signatures.some(sig => sig.role.toLowerCase() === rol.toLowerCase()) ? 'green' : 'grey'"
                  small
                  class="ma-1 white--text"
                >
                  {{ rol }}
                </v-chip>
              </td>
              <td class="table__item center" v-if="item.pdf_url">
                <v-btn icon color="primary" @click="abrirDocumento(item)">
                  <v-icon>mdi-eye</v-icon>
                </v-btn>
              </td>
              <td class="table__item center" v-else>
                <v-btn icon color="primary" @click="abrirDialogoContrato(item)">
                  <v-icon >mdi-file-upload</v-icon>
                </v-btn>
              </td>
            </tr>
          </tbody>
        </template>
      </v-data-table>

      <v-dialog v-model="dialogContrato" max-width="800" persistent scrollable>
        <v-card>
          <v-card-title style="font-family: 'montserrat-bold'; font-size: 24px;">
            Contrato de Factoraje
          </v-card-title>

          <v-card-text>
            <!-- Encabezado -->
            <div class="mb-4" style="font-family: 'montserrat-regular'; font-size: 15px; color: #555;">
              A continuación se presenta el contrato entre las partes para habilitar operaciones de factoraje. Por favor, revisa cuidadosamente el contenido y firma si estás de acuerdo.
            </div>

            <!-- Contenido del contrato -->
            <v-sheet
              class="grey lighten-4 px-4 py-4"
              height="300"
              style="font-family: 'montserrat-regular'; overflow-y: auto; border-radius: 12px; border: 1px solid #ddd;"
            >
              <div v-html="contractHtml"></div>
            </v-sheet>

            <!-- Sección de firmas -->
            <div class="mt-6" style="border-top: 1px solid #ccc; padding-top: 24px;">
              <div class="mb-3" style="font-family: 'montserrat-semibold'; font-size: 16px;">
                Firmas requeridas
              </div>

              <v-row>
                <v-col cols="12" md="4" v-for="(signer, index) in signers" :key="index" style="text-align: center;">
                  <div style="font-family: 'montserrat-semibold';">{{ signer.label }}</div>
                  <div v-if="signer.signed" style="color: green; font-family: 'montserrat-bold';">✅ Firmado</div>
                  <div v-else style="color: red;">❌ Pendiente</div>
                  <div style="font-size: 12px; color: #888;" v-if="signer.date">Firmado el {{ signer.date }}</div>
                  <div v-if="!signer.signed" class="mt-2">
                    <v-btn
                      small
                      text
                      color="#0075B8"
                      @click="signContract(signer.role)"
                    >
                      Firmar
                    </v-btn>
                  </div>
                </v-col>
              </v-row>
            </div>
          </v-card-text>

          <v-card-actions class="justify-end">
            <v-btn
              text
              @click="dialogContrato = false"
              style="font-family: 'montserrat-semibold'; text-transform: none;"
            >
              Cerrar
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <v-dialog v-model="dialogoCargaContrato" max-width="500">
        <v-card>
          <v-card-title class="headline">Cargar contrato en PDF</v-card-title>

          <v-card-text>
            <v-col cols="12">
              <v-card
                class="pa-3 d-flex align-center justify-center"
                outlined
                style="cursor: pointer; border: 2px dashed #0075B8;"
                @click="$refs.uploader.click()"
              >
                <v-icon size="32" color="#0075B8">mdi-plus</v-icon>
                <span class="ml-2 font-weight-medium">Agregar documento</span>
                <input
                  ref="uploader"
                  type="file"
                  accept="application/pdf"
                  style="display: none"
                  @change="archivoSeleccionado"
                />
              </v-card>

              <div v-if="archivoPdf" class="mt-4">
                <v-icon left color="green">mdi-file-pdf-box</v-icon>
                {{ archivoPdf.name }}
              </div>
            </v-col>
          </v-card-text>

          <v-card-actions class="justify-end">
            <v-btn text @click="dialogoCargaContrato = false">Cancelar</v-btn>
            <v-btn :disabled="!archivoPdf" color="primary" @click="subirContrato">Cargar</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

    </v-container>
  </div>
</template>

<script>
import moment from "moment";
export default {
  data() {
    return {
      search: "",
      dialogContrato: false,
      contratoSeleccionado: null,
      contractHtml: '',
      signers: [],
      headers: [
        { text: 'Cliente', value: 'cliente' },
        { text: 'Fecha', value: 'fecha' },
        { text: 'Línea autorizada', value: 'linea' },
        { text: 'Tasa de interés', value: 'tasa' },
        { text: 'Días de crédito', value: 'plazo' },
        { text: 'Firmas', value: 'firmas' },
        { text: '', value: 'acciones', sortable: false }
      ],
      contratos: [],
      userRole: 'admin',
      dialogoCargaContrato: false,
      contratoSeleccionadoParaPdf: null,
      archivoPdf: null
    };
  },
  methods: {
    async getContracts() {
      try {
        this.isLoading = true;

        const response = await DB.get(`${URI}/api/v1/en/contracts/admin/contracts`, {
          headers: {
            Authorization: this.$store.state.sToken
              ? `Bearer ${this.$store.state.sToken}`
              : ""
          }
        });

        this.isLoading = false;
        this.contratos = response.data.contracts;
      } catch (error) {
        if (error.response?.data?.code) {
          this.$router.push("/welcome").catch(() => {});
        }
      } finally {
        this.isLoading = false;
      }
    },
    formatMoney(value) {
      return new Intl.NumberFormat('en-US', {
        style: 'decimal',
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
      }).format(value);
    },
    verContrato(contrato) {
      this.contratoSeleccionado = contrato;
      this.dialogContrato = true;
      this.signers = [
        { label: contrato.cedente_name, signed: contrato.signatures.includes('proveedor'), date: contrato.signed_proveedor_at, role: 'proveedor' },
        { label: contrato.deudor_name, signed: contrato.signatures.includes('deudor'), date: contrato.signed_deudor_at, role: 'deudor' },
        { label: 'FresherPay', signed: contrato.signatures.includes('admin'), date: contrato.signed_admin_at, role: 'admin' }
      ];
      this.contractHtml = contrato.html_snapshot || '';
    },
    formatDate: function (date) {
      if (this.selectLanguage === "sp") {
        moment.locale("es");
      } else {
        moment.locale("en");
      }
      let newDate = moment(date);
      let formattedDate = newDate.format("MMMM DD, YYYY");
      return formattedDate;
    },
    signContract(userRole) {
      const signer = this.signers.find(s => s.role === userRole);
      if (signer) {
        signer.signed = true;
        signer.date = new Date().toLocaleDateString();
      }
    },
    abrirDialogoContrato(contrato) {
      this.contratoSeleccionadoParaPdf = contrato.id;
      this.archivoPdf = null;
      this.dialogoCargaContrato = true;
    },
    archivoSeleccionado(event) {
      this.archivoPdf = event.target.files[0];
    },
    abrirDocumento(doc) {
      window.open(`${doc.file_url}`, '_blank');
    },
    async subirContrato() {
      if (!this.archivoPdf || !this.contratoSeleccionadoParaPdf) return;

      const formData = new FormData();
      formData.append("file", this.archivoPdf);
      formData.append("contractId", this.contratoSeleccionadoParaPdf);

      try {
        await DB.post(`${URI}/api/v1/en/contracts/upload-pdf`, formData, {
          headers: {
            Authorization: `Bearer ${this.$store.state.sToken}`,
            "Content-Type": "multipart/form-data"
          }
        });
        this.$toast.success("Contrato cargado exitosamente.");
        this.dialogoCargaContrato = false;
        this.getContracts(); 
      } catch (err) {
        this.$toast.error("Error al cargar contrato.");
      }
    },
  },
  computed: {
    userAlreadySigned() {
      const current = this.signers.find(s => s.role === this.userRole);
      return current?.signed;
    },
  },
  beforeMount() {
    this.getContracts();
  },
};
</script>

<style scoped>
.header__title {
  font-family: 'montserrat-semibold';
  font-size: 13px;
  padding: 12px;
}
.header__title.left {
  text-align: left;
}
.header__title.center {
  text-align: center;
}
</style>
